import React, { useEffect, useMemo } from 'react';
import { Box, FormLabel, ListItemText, MenuItem, Select, Tooltip, Chip } from '@mui/material';
import CheckBox from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlank from '@mui/icons-material/CheckBoxOutlineBlank';
import { minimalLabelTheme } from '@/app/theme';
import { useDispatch, useSelector } from 'react-redux';
import { setFilters } from '@/features/table/instantSearchSlice';
import { useLocation } from 'react-router-dom';

export const ClientTypeRefinementListSelect = ({
	title,
	disabled,
	prospectFilter,
	setProspectFilter,
	slug: slugProp,
	...props
}) => {
	const dispatch = useDispatch();
	const { pathname } = useLocation();
	const slug = slugProp ?? pathname;


	const refactoredItems = useMemo(() => {
		return [
			{
				label: 'All',
				isRefined: false,
				value: '',
			},
			{
				label: 'Prospect',
				isRefined: prospectFilter.includes('isProspect:= true'),
				value: 'isProspect:= true',
			},
			{
				label: 'Client',
				isRefined: prospectFilter.includes('isProspect:!= true'),
				value: 'isProspect:!= true',
			},
		];
	}, [prospectFilter]);

	useEffect(() => {
		dispatch(
			setFilters({
				slug,
				type: 'isProspect',
				values: [],
			}),
		);
	}, [dispatch, slug]);

	const handleChange = (value) => {
		if (!value || prospectFilter.includes(value)) {
			setProspectFilter('');
			dispatch(
				setFilters({
					slug,
					type: 'isProspect',
					values: [],
				}),
			);
		} else {
			setProspectFilter(value);
			dispatch(
				setFilters({
					slug,
					type: 'isProspect',
					values: [value],
				}),
			);
		}
	};

	const chosenValue = useMemo(
		() => refactoredItems.find((i) => i.isRefined)?.value ?? '',
		[refactoredItems],
	);

	const refinedLabels = refactoredItems.filter((i) => i.isRefined).map((i) => i.label);

	return (
		<Box>
			<FormLabel>{title}</FormLabel>
			<Box>
				<Tooltip
					disableFocusListener
					title={refinedLabels.join(', ') || ''}
					placement='top'
				>
					<Select
						fullWidth
						sx={{
							display: 'flex',
							alignItems: 'center',
							minHeight: 35,
						}}
						disabled={disabled}
						value={chosenValue}
						renderValue={(selected) => {
							const selectedItem = refactoredItems.find((i) => i.value === selected);
							return (
								<Box
									sx={{
										display: 'flex',
										alignItems: 'center',
										gap: 0.5,
									}}
								>
									{selectedItem ? (
										<Chip size='small' label={selectedItem.label} />
									) : (
										''
									)}
								</Box>
							);
						}}
					>
						{refactoredItems.map((item) => (
							<MenuItem
								key={`${title}-select-${item.label}`}
								value={item.value}
								onClick={() => handleChange(item.value)}
							>
								<ListItemText primary={item.label} />
							</MenuItem>
						))}
					</Select>
				</Tooltip>
			</Box>
		</Box>
	);
};
